import { Amperes } from '@/features/execute-calculation-set/overmind/calculation/domain/ElectricCurrent';

import { AttentionStatus } from '../../../../../AttentionStatus';
import {
  EvaluationResult,
  type EvaluationResultType
} from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class CurrentEvaluation {
  private readonly ruleName = 'Mv_AcLineSegment_Current';

  constructor(private readonly rulesProvider: ForRuleProviding) {}

  public evaluate(current: number): EvaluationResultType<Amperes> {
    const rule = this.rulesProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(rule?.value, current);
    const value = Amperes.fromAmperes(current);
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
